/**
 * 投入品分类。大类分为化肥和农药，大类下有小类。
 */
export default [{
  name: '化肥',
  children: [
    '氮肥', '磷肥', '钾肥', '复合肥'
  ]
}, {
  name: '农药',
  children: ['除草剂', '杀虫剂', '杀菌剂', '杀螨剂', '杀鼠剂', '生长调节剂']
}]



// WEBPACK FOOTER //
// ./src/components/resource/inputs/inputs-types.js